// extracted by mini-css-extract-plugin
module.exports = {"dropdown-icon":"DropdownIcon_dropdown-icon__1J8wB"};